import { render, staticRenderFns } from "./vsSelect.vue?vue&type=template&id=4d307b72&lang=html"
import script from "./vsSelect.vue?vue&type=script&lang=js"
export * from "./vsSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports